import React from 'react';

export interface IconProps {
  /** Icon size in pixels */
  size?: number | string;
  /** Icon color */
  color?: string;
  /** Additional CSS classes */
  className?: string;
}

export const IconAdd: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18.6667 18.6667"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8 10.6667H0V8H8V0H10.6667V8H18.6667V10.6667H10.6667V18.6667H8V10.6667Z"
      fill={color}
    />
  </svg>
);

export const IconMail: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 26.6667 21.3333"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2.66667 21.3333C1.93333 21.3333 1.30556 21.0722 0.783333 20.55C0.261111 20.0278 0 19.4 0 18.6667V2.66667C0 1.93333 0.261111 1.30556 0.783333 0.783333C1.30556 0.261111 1.93333 0 2.66667 0H24C24.7333 0 25.3611 0.261111 25.8833 0.783333C26.4056 1.30556 26.6667 1.93333 26.6667 2.66667V18.6667C26.6667 19.4 26.4056 20.0278 25.8833 20.55C25.3611 21.0722 24.7333 21.3333 24 21.3333H2.66667ZM13.3333 12L2.66667 5.33333V18.6667H24V5.33333L13.3333 12ZM13.3333 9.33333L24 2.66667H2.66667L13.3333 9.33333ZM2.66667 5.33333V2.66667V18.6667V5.33333Z"
      fill={color}
    />
  </svg>
);

export const IconSearch: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M22.1333 24L13.7333 15.6C13.0667 16.1333 12.3 16.5556 11.4333 16.8667C10.5667 17.1778 9.64445 17.3333 8.66667 17.3333C6.24444 17.3333 4.19444 16.4944 2.51667 14.8167C0.838889 13.1389 0 11.0889 0 8.66667C0 6.24444 0.838889 4.19444 2.51667 2.51667C4.19444 0.838889 6.24444 0 8.66667 0C11.0889 0 13.1389 0.838889 14.8167 2.51667C16.4944 4.19444 17.3333 6.24444 17.3333 8.66667C17.3333 9.64445 17.1778 10.5667 16.8667 11.4333C16.5556 12.3 16.1333 13.0667 15.6 13.7333L24 22.1333L22.1333 24ZM8.66667 14.6667C10.3333 14.6667 11.75 14.0833 12.9167 12.9167C14.0833 11.75 14.6667 10.3333 14.6667 8.66667C14.6667 7 14.0833 5.58333 12.9167 4.41667C11.75 3.25 10.3333 2.66667 8.66667 2.66667C7 2.66667 5.58333 3.25 4.41667 4.41667C3.25 5.58333 2.66667 7 2.66667 8.66667C2.66667 10.3333 3.25 11.75 4.41667 12.9167C5.58333 14.0833 7 14.6667 8.66667 14.6667Z"
      fill={color}
    />
  </svg>
);

export const IconClear: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 26.6667 26.6667"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.53333 20L13.3333 15.2L18.1333 20L20 18.1333L15.2 13.3333L20 8.53333L18.1333 6.66667L13.3333 11.4667L8.53333 6.66667L6.66667 8.53333L11.4667 13.3333L6.66667 18.1333L8.53333 20ZM13.3333 26.6667C11.4889 26.6667 9.75556 26.3167 8.13333 25.6167C6.51111 24.9167 5.1 23.9667 3.9 22.7667C2.7 21.5667 1.75 20.1556 1.05 18.5333C0.35 16.9111 0 15.1778 0 13.3333C0 11.4889 0.35 9.75556 1.05 8.13333C1.75 6.51111 2.7 5.1 3.9 3.9C5.1 2.7 6.51111 1.75 8.13333 1.05C9.75556 0.35 11.4889 0 13.3333 0C15.1778 0 16.9111 0.35 18.5333 1.05C20.1556 1.75 21.5667 2.7 22.7667 3.9C23.9667 5.1 24.9167 6.51111 25.6167 8.13333C26.3167 9.75556 26.6667 11.4889 26.6667 13.3333C26.6667 15.1778 26.3167 16.9111 25.6167 18.5333C24.9167 20.1556 23.9667 21.5667 22.7667 22.7667C21.5667 23.9667 20.1556 24.9167 18.5333 25.6167C16.9111 26.3167 15.1778 26.6667 13.3333 26.6667Z"
      fill={color}
    />
  </svg>
);

export const IconArrowForward: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21.3333 21.3333"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.2333 12H0V9.33333H16.2333L8.76667 1.86667L10.6667 0L21.3333 10.6667L10.6667 21.3333L8.76667 19.4667L16.2333 12Z"
      fill={color}
    />
  </svg>
);

export const IconLogout: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2.66667 24C1.93333 24 1.30556 23.7389 0.783333 23.2167C0.261111 22.6944 0 22.0667 0 21.3333V2.66667C0 1.93333 0.261111 1.30556 0.783333 0.783333C1.30556 0.261111 1.93333 0 2.66667 0H12V2.66667H2.66667V21.3333H12V24H2.66667ZM17.3333 18.6667L15.5 16.7333L18.9 13.3333H8V10.6667H18.9L15.5 7.26667L17.3333 5.33333L24 12L17.3333 18.6667Z"
      fill={color}
    />
  </svg>
);

export const IconFilter: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.33333 16V13.3333H14.6667V16H9.33333ZM4 9.33333V6.66667H20V9.33333H4ZM0 2.66667V0H24V2.66667H0Z"
      fill={color}
    />
  </svg>
);

export const IconLightning: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21.3333 26.6667"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.73333 21.6L15.6333 13.3333H10.3L11.2667 5.76667L5.1 14.6667H9.73333L8.73333 21.6ZM5.33333 26.6667L6.66667 17.3333H0L12 0H14.6667L13.3333 10.6667H21.3333L8 26.6667H5.33333Z"
      fill={color}
    />
  </svg>
);

export const IconLayers: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 25.4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12 25.4L0 16.0667L2.2 14.4L12 22L21.8 14.4L24 16.0667L12 25.4ZM12 18.6667L0 9.33333L12 0L24 9.33333L12 18.6667ZM12 15.2667L19.6667 9.33333L12 3.4L4.33333 9.33333L12 15.2667Z"
      fill={color}
    />
  </svg>
);

export const IconSelectFromList: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 27.2315 19.1799"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.9243 13.8577H1.95429C1.43598 13.8577 0.938897 13.6495 0.572397 13.2789C0.205898 12.9083 0 12.4056 0 11.8815C0 11.3573 0.205898 10.8547 0.572397 10.484C0.938897 10.1134 1.43598 9.9052 1.95429 9.9052H13.9243C14.4426 9.9052 14.9397 10.1134 15.3062 10.484C15.6727 10.8547 15.8786 11.3573 15.8786 11.8815C15.8786 12.4056 15.6727 12.9083 15.3062 13.2789C14.9397 13.6495 14.4426 13.8577 13.9243 13.8577ZM22.8814 3.95253H1.95429C1.43598 3.95253 0.938897 3.74431 0.572397 3.37369C0.205898 3.00307 0 2.5004 0 1.97626C0 1.45213 0.205898 0.949455 0.572397 0.578834C0.938897 0.208213 1.43598 0 1.95429 0H22.8814C23.3997 0 23.8968 0.208213 24.2633 0.578834C24.6298 0.949455 24.8357 1.45213 24.8357 1.97626C24.8357 2.5004 24.6298 3.00307 24.2633 3.37369C23.8968 3.74431 23.3997 3.95253 22.8814 3.95253Z"
      fill={color}
    />
    <path
      d="M27.0612 17.1977C27.2351 17.3746 27.2339 17.6605 27.0612 17.8353L25.9012 19.0077C25.7282 19.1825 25.4454 19.1825 25.2714 19.0077L23.8192 17.5398C23.727 17.4465 23.5678 17.4773 23.5185 17.6044L23.1015 18.69C22.8448 19.3594 21.8975 19.3382 21.6733 18.655L20.4306 14.894C20.2179 14.9385 19.9968 14.965 19.7705 14.965C17.962 14.965 16.4909 13.4779 16.4909 11.6499C16.4909 9.82179 17.962 8.33474 19.7705 8.33474C21.579 8.33474 23.0501 9.82179 23.0501 11.6499C23.0501 11.8733 23.0271 12.0926 22.9852 12.3034L24.6292 12.8584C24.6983 12.8817 24.735 12.9569 24.7119 13.0257C24.6899 13.0956 24.6156 13.1327 24.5464 13.1094L20.5071 11.7463C20.3248 11.6848 20.1341 11.7304 19.9979 11.8681C19.8617 12.0057 19.8166 12.1985 19.8774 12.3828L21.9217 18.5714C22.0694 19.0194 22.6897 19.0321 22.8573 18.5936L23.2743 17.508C23.3896 17.2062 23.7752 17.1225 24.0047 17.3523L25.4559 18.8203C25.5282 18.8923 25.6444 18.8923 25.7157 18.8203L26.8757 17.6478C26.948 17.5758 26.9468 17.4572 26.8757 17.3852L25.4234 15.9183C25.1971 15.6873 25.2787 15.2966 25.5786 15.18L26.6524 14.7585C27.0872 14.588 27.0717 13.9609 26.6294 13.8127L25.7891 13.5288C25.721 13.5056 25.6832 13.4303 25.7062 13.3615C25.7292 13.2916 25.8038 13.2545 25.8719 13.2778L26.7122 13.5617C27.3871 13.7883 27.4101 14.7458 26.7468 15.0053L25.6727 15.4268C25.548 15.4755 25.5157 15.6355 25.6088 15.7308L27.0612 17.1977Z"
      fill={color}
    />
  </svg>
);

export const IconGenStars: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M19.2351 13.32L19.2626 13.3875C20.1826 15.7175 22.0451 17.5825 24.3751 18.5L24.4426 18.5275L24.3751 18.555C22.0451 19.475 20.1801 21.3375 19.2626 23.6675L19.2351 23.735L19.2076 23.6675C18.2876 21.3375 16.4251 19.4725 14.0951 18.555L14.0276 18.5275L14.0951 18.5C16.4251 17.58 18.2901 15.7175 19.2076 13.3875L19.2351 13.32ZM19.2351 7.4075C19.0351 7.4075 18.8351 7.5175 18.7501 7.7375L16.8851 12.4675C16.2176 14.1625 14.8751 15.505 13.1801 16.1725L8.4501 18.0375C8.0101 18.2125 8.0101 18.835 8.4501 19.01L13.1801 20.875C14.8751 21.5425 16.2176 22.885 16.8851 24.58L18.7501 29.31C18.8376 29.53 19.0376 29.64 19.2351 29.64C19.4326 29.64 19.6351 29.53 19.7201 29.31L21.5851 24.58C22.2526 22.885 23.5951 21.5425 25.2901 20.875L30.0201 19.01C30.4601 18.835 30.4601 18.2125 30.0201 18.0375L25.2901 16.1725C23.5951 15.505 22.2526 14.1625 21.5851 12.4675L19.7201 7.7375C19.6326 7.5175 19.4326 7.4075 19.2351 7.4075ZM7.2351 14.5625L5.9901 12.285C5.9726 12.2525 5.9451 12.225 5.9101 12.205L3.63258 10.96C3.31258 10.785 3.31258 10.3275 3.63258 10.1525L5.9101 8.9075C5.9426 8.89 5.9701 8.8625 5.9876 8.83L7.2326 6.5525C7.4076 6.2325 7.8651 6.2325 8.0401 6.5525L9.2851 8.83C9.3026 8.8625 9.3301 8.89 9.3651 8.91L11.6426 10.155C11.9626 10.33 11.9626 10.7875 11.6426 10.9625L9.3651 12.2075C9.3326 12.225 9.3051 12.2525 9.2876 12.285L8.0426 14.5625C7.8676 14.8825 7.4101 14.8825 7.2351 14.5625Z"
      fill={color}
    />
    <path
      d="M19.2351 13.32L19.2626 13.3875C20.1826 15.7175 22.0451 17.5825 24.3751 18.5L24.4426 18.5275L24.3751 18.555C22.0451 19.475 20.1801 21.3375 19.2626 23.6675L19.2351 23.735L19.2076 23.6675C18.2876 21.3375 16.4251 19.4725 14.0951 18.555L14.0276 18.5275L14.0951 18.5C16.4251 17.58 18.2901 15.7175 19.2076 13.3875L19.2351 13.32Z"
      fill={color}
    />
    <path
      d="M16 5.36755C16.8284 5.36755 17.5 4.69598 17.5 3.86755C17.5 3.03912 16.8284 2.36755 16 2.36755C15.1715 2.36755 14.5 3.03912 14.5 3.86755C14.5 4.69598 15.1715 5.36755 16 5.36755Z"
      fill={color}
    />
  </svg>
);

export const IconSearchList: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28.6666 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M0 25C0 24.4477 0.44772 24 1 24H26.3333C26.8856 24 27.3333 24.4477 27.3333 25C27.3333 25.5523 26.8856 26 26.3333 26H1C0.44772 26 0 25.5523 0 25Z"
      fill="var(--color-primary-light, #B7A8F7)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.33333 8.8C9.33333 3.93989 13.2732 0 18.1333 0C22.9935 0 26.9333 3.93989 26.9333 8.8C26.9333 10.8697 26.2188 12.7727 25.0229 14.2753L28.3737 17.6263C28.7643 18.0168 28.7643 18.6499 28.3737 19.0404C27.9832 19.4309 27.3501 19.4309 26.9596 19.0404L23.6087 15.6896C22.106 16.8855 20.2031 17.6 18.1333 17.6C13.2732 17.6 9.33333 13.6601 9.33333 8.8ZM18.1333 2C14.3777 2 11.3333 5.04447 11.3333 8.8C11.3333 12.5556 14.3777 15.6 18.1333 15.6C21.8889 15.6 24.9333 12.5556 24.9333 8.8C24.9333 5.04447 21.8889 2 18.1333 2ZM0 4.99999C0 4.44771 0.44772 4 1.00001 4L6.33335 4.00004C6.88563 4.00004 7.33333 4.44776 7.33333 5.00004C7.33333 5.55233 6.88561 6.00004 6.33332 6.00004L0.999987 6C0.447707 6 0 5.55228 0 4.99999Z"
      fill={color}
    />
    <path
      d="M0 14.3333C0 13.7811 0.44772 13.3333 1 13.3333H6.33333C6.88561 13.3333 7.33333 13.7811 7.33333 14.3333C7.33333 14.8856 6.88561 15.3333 6.33333 15.3333H1C0.44772 15.3333 0 14.8856 0 14.3333Z"
      fill="var(--color-primary-light, #B7A8F7)"
    />
  </svg>
);

export const IconSearchStars: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22.3675 22.7588"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12.3407 5.69921C13.4934 5.46726 14.5514 4.90664 15.3832 4.08704C16.2151 3.26745 16.7841 2.22502 17.0195 1.08938L15.2605 0.735686C15.0955 1.53157 14.6968 2.26215 14.1139 2.83659C13.5309 3.41103 12.7895 3.80402 11.9818 3.96669L12.3407 5.69921ZM12.3407 4.03684C13.2591 4.22135 13.2591 5.5147 12.3407 5.69921L11.9818 3.96669C10.9856 4.16712 10.9856 5.56893 11.9818 5.76936L12.3407 4.03684ZM17.0195 8.64667C16.7841 7.51103 16.2151 6.46861 15.3832 5.64901C14.5514 4.82941 13.4934 4.26879 12.3407 4.03684L11.9818 5.76936C12.7895 5.93204 13.5309 6.32502 14.1139 6.89947C14.6968 7.47391 15.0955 8.20448 15.2605 9.00037L17.0195 8.64667ZM15.3323 8.64667C15.5196 7.7418 16.8317 7.7418 17.0195 8.64667L15.2605 9.00037C15.4639 9.98128 16.8867 9.98128 17.0907 9.00037L15.3323 8.64667ZM20.0111 4.03684C18.8584 4.26879 17.8004 4.82941 16.9686 5.64901C16.1367 6.46861 15.5677 7.51103 15.3323 8.64667L17.0907 9.00037C17.2557 8.2044 17.6545 7.47378 18.2376 6.89932C18.8206 6.32487 19.5622 5.93193 20.3701 5.76936L20.0111 4.03684ZM20.0111 5.69921C19.0921 5.5147 19.0921 4.22135 20.0111 4.03684L20.3701 5.76936C21.3656 5.56893 21.3656 4.16712 20.3701 3.96669L20.0111 5.69921ZM15.3323 1.08938C15.5677 2.22502 16.1367 3.26745 16.9686 4.08704C17.8004 4.90664 18.8584 5.46726 20.0111 5.69921L20.3701 3.96669C19.5622 3.80412 18.8206 3.41118 18.2376 2.83673C17.6545 2.26228 17.2557 1.53165 17.0907 0.735686L15.3323 1.08938ZM17.0907 0.735686C16.8873 -0.245229 15.4639 -0.245229 15.2605 0.735686L17.0195 1.08938C16.8317 1.99425 15.5196 1.99425 15.3323 1.08938L17.0907 0.735686ZM11.6509 9.43777C11.7257 9.077 12.2492 9.077 12.324 9.43777C12.4053 9.8275 12.6008 10.1852 12.8863 10.4665C13.1719 10.7478 13.5349 10.9405 13.9304 11.0206C14.2972 11.0948 14.2972 11.6101 13.9304 11.6843C13.5349 11.7644 13.1719 11.957 12.8863 12.2384C12.6008 12.5197 12.4053 12.8774 12.324 13.2671C12.2492 13.6279 11.7257 13.6279 11.6509 13.2671C11.5696 12.8774 11.3741 12.5197 11.0885 12.2384C10.803 11.957 10.44 11.7644 10.0444 11.6843C9.67826 11.6101 9.67826 11.0948 10.0444 11.0206C10.44 10.9405 10.803 10.7478 11.0885 10.4665C11.3741 10.1852 11.5696 9.8275 11.6509 9.43777Z"
      fill={color}
    />
    <path
      d="M10.2185 2.49237C10.3381 2.49157 10.4562 2.46725 10.5661 2.42084C10.6759 2.37442 10.7753 2.30686 10.8583 2.2221C10.9413 2.13735 11.0062 2.03711 11.0494 1.92728C11.0925 1.81744 11.113 1.70023 11.1095 1.58251C11.106 1.46479 11.0787 1.34893 11.0292 1.24175C10.9797 1.13457 10.9089 1.03821 10.8211 0.958341C10.7332 0.87847 10.6301 0.816693 10.5177 0.776636C10.4053 0.736579 10.2859 0.71905 10.1665 0.725076L10.2185 2.49237ZM20.9367 10.7376C20.9333 10.6215 20.9067 10.5072 20.8585 10.4011C20.8103 10.2951 20.7413 10.1995 20.6556 10.1198C20.5699 10.04 20.469 9.97768 20.3589 9.93632C20.2487 9.89496 20.1313 9.87539 20.0135 9.87871C19.8956 9.88204 19.7796 9.90821 19.672 9.95572C19.5644 10.0032 19.4673 10.0712 19.3864 10.1556C19.3054 10.2401 19.2422 10.3394 19.2002 10.448C19.1582 10.5565 19.1383 10.6722 19.1417 10.7883L20.9367 10.7376ZM20.8349 22.4997C21.0033 22.6656 21.2316 22.7588 21.4697 22.7588C21.7078 22.7588 21.9362 22.6656 22.1046 22.4997C22.2729 22.3339 22.3675 22.1089 22.3675 21.8743C22.3675 21.6397 22.2729 21.4147 22.1046 21.2488L20.8349 22.4997ZM16.6049 17.0805C13.2167 20.4188 7.72358 20.4188 4.33595 17.0805L3.06694 18.3314C7.15579 22.36 13.7851 22.36 17.8739 18.3314L16.6049 17.0805ZM4.33595 17.0805C0.947723 13.7428 0.947723 8.33071 4.33595 4.99241L3.06634 3.7421C-1.02251 7.77069 -1.02191 14.3029 3.06694 18.3314L4.33595 17.0805ZM4.33595 4.99241C5.89961 3.44781 8.00517 2.55259 10.2185 2.49237L10.1665 0.725076C7.495 0.798532 4.95383 1.87796 3.06634 3.7421L4.33595 4.99241ZM19.1417 10.7883C19.1774 11.9523 18.9713 13.1111 18.5349 14.1933C18.0985 15.2755 17.4416 16.2581 16.6049 17.0805L17.8739 18.3314C18.8836 17.3387 19.6762 16.1528 20.2029 14.8468C20.7297 13.5408 20.9794 12.1423 20.9367 10.7376L19.1417 10.7883ZM16.6049 18.332L20.8349 22.4997L22.1046 21.25L17.8745 17.0811L16.6049 18.332Z"
      fill="var(--color-primary-light, #B7A8F7)"
    />
  </svg>
);

export const IconArrowBackward: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21.3333 21.3333"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.1 12L12.5667 19.4667L10.6667 21.3333L0 10.6667L10.6667 0L12.5667 1.86667L5.1 9.33333H21.3333V12H5.1Z"
      fill={color}
    />
  </svg>
);

export const IconCheck: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21.7333 16.0333"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.6 16.0333L0 8.43333L1.9 6.53333L7.6 12.2333L19.8333 0L21.7333 1.9L7.6 16.0333Z"
      fill={color}
    />
  </svg>
);

export const IconArrowDown: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 9.86667"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8 9.86667L0 1.86667L1.86667 0L8 6.13333L14.1333 0L16 1.86667L8 9.86667Z"
      fill={color}
    />
  </svg>
);

export const IconArrowDropDown: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13.3333 6.66667"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M6.66667 6.66667L0 0H13.3333L6.66667 6.66667Z" fill={color} />
  </svg>
);

export const IconClose: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18.6667 18.6667"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1.86667 18.6667L0 16.8L7.46667 9.33333L0 1.86667L1.86667 0L9.33333 7.46667L16.8 0L18.6667 1.86667L11.2 9.33333L18.6667 16.8L16.8 18.6667L9.33333 11.2L1.86667 18.6667Z"
      fill={color}
    />
  </svg>
);

export const IconDatabaseCheck: React.FC<IconProps> = ({ size = 20, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0267 22.5333C12.1692 20.5377 12.8361 18.6151 13.96 16.96C11.8667 17.3067 9.78667 17.3333 9.33333 17.3333C8.37333 17.3333 0 17.24 0 14V19.3333C0 22.5733 8.37333 22.6667 9.33333 22.6667C9.64 22.6667 10.72 22.6533 12.0267 22.5333ZM9.33333 14.6667C10.288 14.6667 18.6667 14.5733 18.6667 11.3333V6C18.6667 9.24 10.288 9.33333 9.33333 9.33333C8.37867 9.33333 0 9.24 0 6V11.3333C0 14.5733 8.37867 14.6667 9.33333 14.6667Z"
      fill="var(--color-primary-light, #B7A8F7)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.3333 14.6667C18.5547 14.6667 14.6667 18.5547 14.6667 23.3333C14.6667 28.112 18.5547 32 23.3333 32C28.112 32 32 28.112 32 23.3333C32 18.5547 28.112 14.6667 23.3333 14.6667ZM23.0027 26.5453L27.6693 21.212C27.8866 20.9438 27.9916 20.6019 27.9622 20.2581C27.9328 19.9142 27.7714 19.595 27.5117 19.3676C27.2521 19.1403 26.9144 19.0223 26.5696 19.0385C26.2249 19.0547 25.8998 19.2039 25.6627 19.4547L21.9347 23.716L20.276 22.0573C20.1522 21.9335 20.0052 21.8353 19.8435 21.7683C19.6818 21.7014 19.5084 21.6669 19.3333 21.6669C19.1583 21.6669 18.9849 21.7014 18.8232 21.7683C18.6614 21.8353 18.5145 21.9335 18.3907 22.0573C18.2669 22.1811 18.1687 22.3281 18.1017 22.4898C18.0347 22.6516 18.0002 22.8249 18.0002 23C18.0002 23.1751 18.0347 23.3484 18.1017 23.5102C18.1687 23.6719 18.2669 23.8189 18.3907 23.9427L21.0573 26.6093C21.3073 26.8594 21.6464 26.9999 22 27H22.044C22.2264 26.9939 22.4056 26.9505 22.5706 26.8722C22.7355 26.794 22.8826 26.6828 23.0027 26.5453Z"
      fill="#10B981"
    />
    <path
      d="M9.33333 6.66667C8.37867 6.66667 0 6.57333 0 3.33333C0 0.0933332 8.37867 0 9.33333 0C10.288 0 18.6667 0.0933332 18.6667 3.33333C18.6667 6.57333 10.288 6.66667 9.33333 6.66667Z"
      fill="var(--color-primary-light, #B7A8F7)"
    />
  </svg>
);

export const IconLoading: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className}`}
    style={{
      animation: 'spin 1s linear infinite',
    }}
  >
    <style>{`
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `}</style>
    <path
      d="M12 4V2C6.48 2 2 6.48 2 12s4.48 10 10 10c5.52 0 10-4.48 10-10h-2c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8z"
      fill={color}
    />
  </svg>
);

export const IconOpenInNew: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.66667 28C5.93333 28 5.30556 27.7389 4.78333 27.2167C4.26111 26.6944 4 26.0667 4 25.3333V6.66667C4 5.93333 4.26111 5.30556 4.78333 4.78333C5.30556 4.26111 5.93333 4 6.66667 4H16V6.66667H6.66667V25.3333H25.3333V16H28V25.3333C28 26.0667 27.7389 26.6944 27.2167 27.2167C26.6944 27.7389 26.0667 28 25.3333 28H6.66667ZM12.9333 20.9333L11.0667 19.0667L23.4667 6.66667H18.6667V4H28V13.3333H25.3333V8.53333L12.9333 20.9333Z"
      fill={color}
    />
  </svg>
);

export const IconAvatar: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.79996 22.8C8.93329 21.9334 10.2 21.25 11.6 20.75C13 20.25 14.4666 20 16 20C17.5333 20 19 20.25 20.4 20.75C21.8 21.25 23.0666 21.9334 24.2 22.8C24.9777 21.8889 25.5833 20.8556 26.0166 19.7C26.45 18.5445 26.6666 17.3111 26.6666 16C26.6666 13.0445 25.6277 10.5278 23.55 8.45002C21.4722 6.37224 18.9555 5.33335 16 5.33335C13.0444 5.33335 10.5277 6.37224 8.44996 8.45002C6.37218 10.5278 5.33329 13.0445 5.33329 16C5.33329 17.3111 5.54996 18.5445 5.98329 19.7C6.41663 20.8556 7.02218 21.8889 7.79996 22.8ZM16 17.3334C14.6888 17.3334 13.5833 16.8834 12.6833 15.9834C11.7833 15.0834 11.3333 13.9778 11.3333 12.6667C11.3333 11.3556 11.7833 10.25 12.6833 9.35002C13.5833 8.45002 14.6888 8.00002 16 8.00002C17.3111 8.00002 18.4166 8.45002 19.3166 9.35002C20.2166 10.25 20.6666 11.3556 20.6666 12.6667C20.6666 13.9778 20.2166 15.0834 19.3166 15.9834C18.4166 16.8834 17.3111 17.3334 16 17.3334ZM16 29.3334C14.1555 29.3334 12.4222 28.9834 10.8 28.2834C9.17774 27.5834 7.76663 26.6334 6.56663 25.4334C5.36663 24.2334 4.41663 22.8222 3.71663 21.2C3.01663 19.5778 2.66663 17.8445 2.66663 16C2.66663 14.1556 3.01663 12.4222 3.71663 10.8C4.41663 9.1778 5.36663 7.76669 6.56663 6.56669C7.76663 5.36669 9.17774 4.41669 10.8 3.71669C12.4222 3.01669 14.1555 2.66669 16 2.66669C17.8444 2.66669 19.5777 3.01669 21.2 3.71669C22.8222 4.41669 24.2333 5.36669 25.4333 6.56669C26.6333 7.76669 27.5833 9.1778 28.2833 10.8C28.9833 12.4222 29.3333 14.1556 29.3333 16C29.3333 17.8445 28.9833 19.5778 28.2833 21.2C27.5833 22.8222 26.6333 24.2334 25.4333 25.4334C24.2333 26.6334 22.8222 27.5834 21.2 28.2834C19.5777 28.9834 17.8444 29.3334 16 29.3334ZM16 26.6667C17.1777 26.6667 18.2888 26.4945 19.3333 26.15C20.3777 25.8056 21.3333 25.3111 22.2 24.6667C21.3333 24.0222 20.3777 23.5278 19.3333 23.1834C18.2888 22.8389 17.1777 22.6667 16 22.6667C14.8222 22.6667 13.7111 22.8389 12.6666 23.1834C11.6222 23.5278 10.6666 24.0222 9.79996 24.6667C10.6666 25.3111 11.6222 25.8056 12.6666 26.15C13.7111 26.4945 14.8222 26.6667 16 26.6667ZM16 14.6667C16.5777 14.6667 17.0555 14.4778 17.4333 14.1C17.8111 13.7222 18 13.2445 18 12.6667C18 12.0889 17.8111 11.6111 17.4333 11.2334C17.0555 10.8556 16.5777 10.6667 16 10.6667C15.4222 10.6667 14.9444 10.8556 14.5666 11.2334C14.1888 11.6111 14 12.0889 14 12.6667C14 13.2445 14.1888 13.7222 14.5666 14.1C14.9444 14.4778 15.4222 14.6667 16 14.6667Z"
      fill={color}
    />
  </svg>
);

export const IconMessageRead: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M23.1333 26.6667L18.4333 21.9334L20.3 20.0667L23.1333 22.9L28.8 17.2334L30.6666 19.1334L23.1333 26.6667ZM2.66663 29.3334V5.33335C2.66663 4.60002 2.92774 3.97224 3.44996 3.45002C3.97218 2.9278 4.59996 2.66669 5.33329 2.66669H26.6666C27.4 2.66669 28.0277 2.9278 28.55 3.45002C29.0722 3.97224 29.3333 4.60002 29.3333 5.33335V14.6667H26.6666V5.33335H5.33329V22.8334L6.86663 21.3334H16V24H7.99996L2.66663 29.3334Z"
      fill={color}
    />
  </svg>
);

export const IconGroup: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M0 24V21.9C0 20.9444 0.488889 20.1667 1.46667 19.5667C2.44444 18.9667 3.73333 18.6667 5.33333 18.6667C5.62222 18.6667 5.9 18.6722 6.16667 18.6833C6.43333 18.6944 6.68889 18.7222 6.93333 18.7667C6.62222 19.2333 6.38889 19.7222 6.23333 20.2333C6.07778 20.7444 6 21.2778 6 21.8333V24H0ZM8 24V21.8333C8 21.1222 8.19444 20.4722 8.58333 19.8833C8.97222 19.2944 9.52222 18.7778 10.2333 18.3333C10.9444 17.8889 11.7944 17.5556 12.7833 17.3333C13.7722 17.1111 14.8444 17 16 17C17.1778 17 18.2611 17.1111 19.25 17.3333C20.2389 17.5556 21.0889 17.8889 21.8 18.3333C22.5111 18.7778 23.0556 19.2944 23.4333 19.8833C23.8111 20.4722 24 21.1222 24 21.8333V24H8ZM26 24V21.8333C26 21.2556 25.9278 20.7111 25.7833 20.2C25.6389 19.6889 25.4222 19.2111 25.1333 18.7667C25.3778 18.7222 25.6278 18.6944 25.8833 18.6833C26.1389 18.6722 26.4 18.6667 26.6667 18.6667C28.2667 18.6667 29.5556 18.9611 30.5333 19.55C31.5111 20.1389 32 20.9222 32 21.9V24H26ZM10.8333 21.3333H21.2C20.9778 20.8889 20.3611 20.5 19.35 20.1667C18.3389 19.8333 17.2222 19.6667 16 19.6667C14.7778 19.6667 13.6611 19.8333 12.65 20.1667C11.6389 20.5 11.0333 20.8889 10.8333 21.3333ZM5.33333 17.3333C4.6 17.3333 3.97222 17.0722 3.45 16.55C2.92778 16.0278 2.66667 15.4 2.66667 14.6667C2.66667 13.9111 2.92778 13.2778 3.45 12.7667C3.97222 12.2556 4.6 12 5.33333 12C6.08889 12 6.72222 12.2556 7.23333 12.7667C7.74444 13.2778 8 13.9111 8 14.6667C8 15.4 7.74444 16.0278 7.23333 16.55C6.72222 17.0722 6.08889 17.3333 5.33333 17.3333ZM26.6667 17.3333C25.9333 17.3333 25.3056 17.0722 24.7833 16.55C24.2611 16.0278 24 15.4 24 14.6667C24 13.9111 24.2611 13.2778 24.7833 12.7667C25.3056 12.2556 25.9333 12 26.6667 12C27.4222 12 28.0556 12.2556 28.5667 12.7667C29.0778 13.2778 29.3333 13.9111 29.3333 14.6667C29.3333 15.4 29.0778 16.0278 28.5667 16.55C28.0556 17.0722 27.4222 17.3333 26.6667 17.3333ZM16 16C14.8889 16 13.9444 15.6111 13.1667 14.8333C12.3889 14.0556 12 13.1111 12 12C12 10.8667 12.3889 9.91667 13.1667 9.15C13.9444 8.38333 14.8889 8 16 8C17.1333 8 18.0833 8.38333 18.85 9.15C19.6167 9.91667 20 10.8667 20 12C20 13.1111 19.6167 14.0556 18.85 14.8333C18.0833 15.6111 17.1333 16 16 16ZM16 13.3333C16.3778 13.3333 16.6944 13.2056 16.95 12.95C17.2056 12.6944 17.3333 12.3778 17.3333 12C17.3333 11.6222 17.2056 11.3056 16.95 11.05C16.6944 10.7944 16.3778 10.6667 16 10.6667C15.6222 10.6667 15.3056 10.7944 15.05 11.05C14.7944 11.3056 14.6667 11.6222 14.6667 12C14.6667 12.3778 14.7944 12.6944 15.05 12.95C15.3056 13.2056 15.6222 13.3333 16 13.3333Z"
      fill={color}
    />
  </svg>
);

export const IconChatDashed: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2.66675 16V10.6667H5.33341V16H2.66675ZM2.66675 29.3334V18.6667H5.33341V22.8334L6.86675 21.3334H10.6667V24H8.00008L2.66675 29.3334ZM13.3334 24V21.3334H18.6667V24H13.3334ZM21.3334 24V21.3334H26.6667V18.6667H29.3334V21.3334C29.3334 22.0667 29.0723 22.6945 28.5501 23.2167C28.0279 23.7389 27.4001 24 26.6667 24H21.3334ZM26.6667 16V10.6667H29.3334V16H26.6667ZM26.6667 8.03335V5.33335H21.3334V2.66669H26.6667C27.4001 2.66669 28.0279 2.9278 28.5501 3.45002C29.0723 3.97224 29.3334 4.60002 29.3334 5.33335V8.03335H26.6667ZM13.3334 5.33335V2.66669H18.6667V5.33335H13.3334ZM2.66675 8.03335V5.33335C2.66675 4.60002 2.92786 3.97224 3.45008 3.45002C3.9723 2.9278 4.60008 2.66669 5.33341 2.66669H10.6667V5.33335H5.33341V8.03335H2.66675Z"
      fill={color}
    />
  </svg>
);

export const IconPhoneOff: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M26.4 30.2667L19 22.8667C17.0223 24.4667 14.8723 25.7222 12.55 26.6333C10.2278 27.5444 7.84448 28 5.40003 28C4.8667 28 4.50003 27.8667 4.30003 27.6C4.10003 27.3333 4.00003 27 4.00003 26.6V21.2C4.00003 20.8889 4.10003 20.6167 4.30003 20.3833C4.50003 20.15 4.75559 20 5.0667 19.9333L9.6667 19C9.91114 18.9556 10.2167 18.9889 10.5834 19.1C10.95 19.2111 11.2223 19.3556 11.4 19.5333L14.5334 22.6667C14.9334 22.4222 15.3667 22.1444 15.8334 21.8333C16.3 21.5222 16.7111 21.2222 17.0667 20.9333L1.8667 5.73334L3.73337 3.86667L28.2667 28.4L26.4 30.2667ZM12 23.8667L9.80003 21.6667L6.6667 22.3333V25.2667C7.57781 25.2 8.47781 25.0444 9.3667 24.8C10.2556 24.5556 11.1334 24.2444 12 23.8667ZM22.7334 19.0667L20.8667 17.2C21.2 16.8222 21.5389 16.3889 21.8834 15.9C22.2278 15.4111 22.5 14.9556 22.7 14.5333L19.4667 11.2667C19.2889 11.0889 19.1667 10.8389 19.1 10.5167C19.0334 10.1944 19.0223 9.93334 19.0667 9.73334L19.9334 5.06667C20 4.75556 20.15 4.5 20.3834 4.3C20.6167 4.1 20.8889 4 21.2 4H26.6C27 4 27.3334 4.13334 27.6 4.4C27.8667 4.66667 28 5 28 5.4C28 7.84445 27.5334 10.2278 26.6 12.55C25.6667 14.8722 24.3778 17.0444 22.7334 19.0667ZM23.9334 12C24.3111 11.1333 24.6 10.2556 24.8 9.36667C25 8.47778 25.1556 7.57778 25.2667 6.66667H22.3334L21.7334 9.8L23.9334 12Z"
      fill={color}
    />
  </svg>
);

export const IconGlobeSearch: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16 29.3333C14.1555 29.3333 12.4222 28.9833 10.8 28.2833C9.17774 27.5833 7.76663 26.6333 6.56663 25.4333C5.36663 24.2333 4.41663 22.8222 3.71663 21.2C3.01663 19.5778 2.66663 17.8444 2.66663 16C2.66663 14.1555 3.01663 12.4222 3.71663 10.8C4.41663 9.17777 5.36663 7.76666 6.56663 6.56666C7.76663 5.36666 9.17774 4.41666 10.8 3.71666C12.4222 3.01666 14.1555 2.66666 16 2.66666C19.2444 2.66666 22.0833 3.68332 24.5166 5.71666C26.95 7.74999 28.4666 10.3 29.0666 13.3667H26.3333C25.9111 11.7444 25.15 10.2944 24.05 9.01666C22.95 7.73888 21.6 6.77777 20 6.13332V6.66666C20 7.39999 19.7388 8.02777 19.2166 8.54999C18.6944 9.07221 18.0666 9.33332 17.3333 9.33332H14.6666V12C14.6666 12.3778 14.5388 12.6944 14.2833 12.95C14.0277 13.2055 13.7111 13.3333 13.3333 13.3333H10.6666V16H13.3333V20H12L5.59996 13.6C5.53329 14 5.47218 14.4 5.41663 14.8C5.36107 15.2 5.33329 15.6 5.33329 16C5.33329 18.9111 6.35552 21.4111 8.39996 23.5C10.4444 25.5889 12.9777 26.6444 16 26.6667V29.3333ZM28.1333 28.6667L23.8666 24.4C23.4 24.6667 22.9 24.8889 22.3666 25.0667C21.8333 25.2444 21.2666 25.3333 20.6666 25.3333C19 25.3333 17.5833 24.75 16.4166 23.5833C15.25 22.4167 14.6666 21 14.6666 19.3333C14.6666 17.6667 15.25 16.25 16.4166 15.0833C17.5833 13.9167 19 13.3333 20.6666 13.3333C22.3333 13.3333 23.75 13.9167 24.9166 15.0833C26.0833 16.25 26.6666 17.6667 26.6666 19.3333C26.6666 19.9333 26.5777 20.5 26.4 21.0333C26.2222 21.5667 26 22.0667 25.7333 22.5333L30 26.8L28.1333 28.6667ZM20.6666 22.6667C21.6 22.6667 22.3888 22.3444 23.0333 21.7C23.6777 21.0555 24 20.2667 24 19.3333C24 18.4 23.6777 17.6111 23.0333 16.9667C22.3888 16.3222 21.6 16 20.6666 16C19.7333 16 18.9444 16.3222 18.3 16.9667C17.6555 17.6111 17.3333 18.4 17.3333 19.3333C17.3333 20.2667 17.6555 21.0555 18.3 21.7C18.9444 22.3444 19.7333 22.6667 20.6666 22.6667Z"
      fill={color}
    />
  </svg>
);

export const IconLink: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14.6666 22.6667H9.33329C7.48885 22.6667 5.91663 22.0167 4.61663 20.7167C3.31663 19.4167 2.66663 17.8445 2.66663 16C2.66663 14.1556 3.31663 12.5833 4.61663 11.2833C5.91663 9.98334 7.48885 9.33334 9.33329 9.33334H14.6666V12H9.33329C8.22218 12 7.27774 12.3889 6.49996 13.1667C5.72218 13.9445 5.33329 14.8889 5.33329 16C5.33329 17.1111 5.72218 18.0556 6.49996 18.8333C7.27774 19.6111 8.22218 20 9.33329 20H14.6666V22.6667ZM10.6666 17.3333V14.6667H21.3333V17.3333H10.6666ZM17.3333 22.6667V20H22.6666C23.7777 20 24.7222 19.6111 25.5 18.8333C26.2777 18.0556 26.6666 17.1111 26.6666 16C26.6666 14.8889 26.2777 13.9445 25.5 13.1667C24.7222 12.3889 23.7777 12 22.6666 12H17.3333V9.33334H22.6666C24.5111 9.33334 26.0833 9.98334 27.3833 11.2833C28.6833 12.5833 29.3333 14.1556 29.3333 16C29.3333 17.8445 28.6833 19.4167 27.3833 20.7167C26.0833 22.0167 24.5111 22.6667 22.6666 22.6667H17.3333Z"
      fill={color}
    />
  </svg>
);

export const IconProfileOff: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M15.1 24C16.2333 24 17.3222 23.8278 18.3667 23.4833C19.4111 23.1389 20.3889 22.6444 21.3 22C20.3889 21.3556 19.4111 20.8611 18.3667 20.5167C17.3222 20.1722 16.2333 20 15.1 20C13.9667 20 12.8778 20.1722 11.8333 20.5167C10.7889 20.8611 9.81111 21.3556 8.9 22C9.81111 22.6444 10.7889 23.1389 11.8333 23.4833C12.8778 23.8278 13.9667 24 15.1 24ZM18.6333 13.0667L16.7333 11.1667C16.8444 10.9889 16.9333 10.8 17 10.6C17.0667 10.4 17.1 10.2 17.1 10C17.1 9.44444 16.9056 8.97222 16.5167 8.58333C16.1278 8.19444 15.6556 8 15.1 8C14.9 8 14.7 8.03333 14.5 8.1C14.3 8.16667 14.1111 8.25556 13.9333 8.36667L12.0333 6.46667C12.4556 6.08889 12.9278 5.80556 13.45 5.61667C13.9722 5.42778 14.5222 5.33333 15.1 5.33333C16.3889 5.33333 17.4889 5.78889 18.4 6.7C19.3111 7.61111 19.7667 8.71111 19.7667 10C19.7667 10.5778 19.6722 11.1278 19.4833 11.65C19.2944 12.1722 19.0111 12.6444 18.6333 13.0667ZM26.2333 20.6667L24.3 18.7333C24.7889 17.9111 25.1556 17.0444 25.4 16.1333C25.6444 15.2222 25.7667 14.2889 25.7667 13.3333C25.7667 10.3556 24.7333 7.83333 22.6667 5.76667C20.6 3.7 18.0778 2.66667 15.1 2.66667C14.1444 2.66667 13.2111 2.78889 12.3 3.03333C11.3889 3.27778 10.5222 3.64444 9.7 4.13333L7.76667 2.2C8.85556 1.48889 10.0222 0.944444 11.2667 0.566667C12.5111 0.188889 13.7889 0 15.1 0C16.9444 0 18.6778 0.35 20.3 1.05C21.9222 1.75 23.3333 2.7 24.5333 3.9C25.7333 5.1 26.6833 6.51111 27.3833 8.13333C28.0833 9.75556 28.4333 11.4889 28.4333 13.3333C28.4333 14.6444 28.2444 15.9222 27.8667 17.1667C27.4889 18.4111 26.9444 19.5778 26.2333 20.6667ZM15.1 26.6667C13.2556 26.6667 11.5222 26.3167 9.9 25.6167C8.27778 24.9167 6.86667 23.9667 5.66667 22.7667C4.46667 21.5667 3.51667 20.1556 2.81667 18.5333C2.11667 16.9111 1.76667 15.1778 1.76667 13.3333C1.76667 12.0222 1.95 10.7444 2.31667 9.5C2.68333 8.25556 3.22222 7.07778 3.93333 5.96667L0 2L1.9 0.1L28.3 26.5L26.4 28.4L5.9 7.93333C5.41111 8.75556 5.04444 9.62222 4.8 10.5333C4.55556 11.4444 4.43333 12.3778 4.43333 13.3333C4.43333 14.6 4.64444 15.8111 5.06667 16.9667C5.48889 18.1222 6.1 19.1778 6.9 20.1333C8.1 19.2222 9.39444 18.5278 10.7833 18.05C12.1722 17.5722 13.6111 17.3333 15.1 17.3333C15.9444 17.3333 16.7889 17.4222 17.6333 17.6C18.4778 17.7778 19.3 18.0222 20.1 18.3333L24.5333 22.7667C23.2667 24.0333 21.8222 25 20.2 25.6667C18.5778 26.3333 16.8778 26.6667 15.1 26.6667Z"
      fill={color}
    />
  </svg>
);

export const IconLightMode: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10 12.5C10.6945 12.5 11.2848 12.2569 11.7709 11.7708C12.257 11.2847 12.5 10.6944 12.5 9.99998C12.5 9.30554 12.257 8.71526 11.7709 8.22915C11.2848 7.74304 10.6945 7.49998 10 7.49998C9.3056 7.49998 8.71532 7.74304 8.22921 8.22915C7.7431 8.71526 7.50004 9.30554 7.50004 9.99998C7.50004 10.6944 7.7431 11.2847 8.22921 11.7708C8.71532 12.2569 9.3056 12.5 10 12.5ZM10 14.1666C8.84726 14.1666 7.86462 13.7604 7.05212 12.9479C6.23962 12.1354 5.83337 11.1528 5.83337 9.99998C5.83337 8.8472 6.23962 7.86456 7.05212 7.05206C7.86462 6.23956 8.84726 5.83331 10 5.83331C11.1528 5.83331 12.1355 6.23956 12.948 7.05206C13.7605 7.86456 14.1667 8.8472 14.1667 9.99998C14.1667 11.1528 13.7605 12.1354 12.948 12.9479C12.1355 13.7604 11.1528 14.1666 10 14.1666ZM4.16671 10.8333H0.833374V9.16665H4.16671V10.8333ZM19.1667 10.8333H15.8334V9.16665H19.1667V10.8333ZM9.16671 4.16665V0.833313H10.8334V4.16665H9.16671ZM9.16671 19.1666V15.8333H10.8334V19.1666H9.16671ZM5.33337 6.45831L3.22921 4.43748L4.41671 3.20831L6.41671 5.29165L5.33337 6.45831ZM15.5834 16.7916L13.5625 14.6875L14.6667 13.5416L16.7709 15.5625L15.5834 16.7916ZM13.5417 5.33331L15.5625 3.22915L16.7917 4.41665L14.7084 6.41665L13.5417 5.33331ZM3.20837 15.5833L5.31254 13.5625L6.45837 14.6666L4.43754 16.7708L3.20837 15.5833Z"
      fill={color}
    />
  </svg>
);

export const IconDarkMode: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10 17.5C7.91667 17.5 6.14583 16.7708 4.6875 15.3125C3.22917 13.8542 2.5 12.0833 2.5 10C2.5 7.91667 3.22917 6.14583 4.6875 4.6875C6.14583 3.22917 7.91667 2.5 10 2.5C10.1944 2.5 10.3854 2.50694 10.5729 2.52083C10.7604 2.53472 10.9444 2.55556 11.125 2.58333C10.5556 2.98611 10.1007 3.51042 9.76042 4.15625C9.42014 4.80208 9.25 5.5 9.25 6.25C9.25 7.5 9.6875 8.5625 10.5625 9.4375C11.4375 10.3125 12.5 10.75 13.75 10.75C14.5139 10.75 15.2153 10.5799 15.8542 10.2396C16.4931 9.89931 17.0139 9.44444 17.4167 8.875C17.4444 9.05556 17.4653 9.23958 17.4792 9.42708C17.4931 9.61458 17.5 9.80556 17.5 10C17.5 12.0833 16.7708 13.8542 15.3125 15.3125C13.8542 16.7708 12.0833 17.5 10 17.5ZM10 15.8333C11.2222 15.8333 12.3194 15.4965 13.2917 14.8229C14.2639 14.1493 14.9722 13.2708 15.4167 12.1875C15.1389 12.2569 14.8611 12.3125 14.5833 12.3542C14.3056 12.3958 14.0278 12.4167 13.75 12.4167C12.0417 12.4167 10.5868 11.816 9.38542 10.6146C8.18403 9.41319 7.58333 7.95833 7.58333 6.25C7.58333 5.97222 7.60417 5.69444 7.64583 5.41667C7.6875 5.13889 7.74306 4.86111 7.8125 4.58333C6.72917 5.02778 5.85069 5.73611 5.17708 6.70833C4.50347 7.68056 4.16667 8.77778 4.16667 10C4.16667 11.6111 4.73611 12.9861 5.875 14.125C7.01389 15.2639 8.38889 15.8333 10 15.8333Z"
      fill={color}
    />
  </svg>
);

export const IconVerified: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 30 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.1333 28L7.6 23.7333L2.8 22.6667L3.26667 17.7333L0 14L3.26667 10.2667L2.8 5.33333L7.6 4.26667L10.1333 0L14.6667 1.93333L19.2 0L21.7333 4.26667L26.5333 5.33333L26.0667 10.2667L29.3333 14L26.0667 17.7333L26.5333 22.6667L21.7333 23.7333L19.2 28L14.6667 26.0667L10.1333 28ZM11.2667 24.6L14.6667 23.1333L18.1333 24.6L20 21.4L23.6667 20.5333L23.3333 16.8L25.8 14L23.3333 11.1333L23.6667 7.4L20 6.6L18.0667 3.4L14.6667 4.86667L11.2 3.4L9.33333 6.6L5.66667 7.4L6 11.1333L3.53333 14L6 16.8L5.66667 20.6L9.33333 21.4L11.2667 24.6ZM13.2667 18.7333L20.8 11.2L18.9333 9.26667L13.2667 14.9333L10.4 12.1333L8.53333 14L13.2667 18.7333Z"
      fill={color}
    />
  </svg>
);

export const IconDoneAll: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.93336 24L1.40002 16.4667L3.30002 14.6L8.96669 20.2667L10.8334 22.1333L8.93336 24ZM16.4667 24L8.93336 16.4667L10.8 14.5667L16.4667 20.2333L28.7334 7.96667L30.6 9.86667L16.4667 24ZM16.4667 16.4667L14.5667 14.6L21.1667 8.00001L23.0667 9.86667L16.4667 16.4667Z"
      fill={color}
    />
  </svg>
);

export const IconLog: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8 22.6667H16V20H8V22.6667ZM12 17.3333H20V14.6667H12V17.3333ZM16 12H24V9.33333H16V12ZM6.66667 28C5.93333 28 5.30556 27.7389 4.78333 27.2167C4.26111 26.6944 4 26.0667 4 25.3333V6.66667C4 5.93333 4.26111 5.30556 4.78333 4.78333C5.30556 4.26111 5.93333 4 6.66667 4H25.3333C26.0667 4 26.6944 4.26111 27.2167 4.78333C27.7389 5.30556 28 5.93333 28 6.66667V25.3333C28 26.0667 27.7389 26.6944 27.2167 27.2167C26.6944 27.7389 26.0667 28 25.3333 28H6.66667ZM6.66667 25.3333H25.3333V6.66667H6.66667V25.3333Z"
      fill={color}
    />
  </svg>
);

export const IconSchedule: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M20.4001 22.2667L22.2667 20.4L17.3334 15.4667V9.33332H14.6667V16.5333L20.4001 22.2667ZM16.0001 29.3333C14.1556 29.3333 12.4223 28.9833 10.8001 28.2833C9.17786 27.5833 7.76675 26.6333 6.56675 25.4333C5.36675 24.2333 4.41675 22.8222 3.71675 21.2C3.01675 19.5778 2.66675 17.8444 2.66675 16C2.66675 14.1555 3.01675 12.4222 3.71675 10.8C4.41675 9.17777 5.36675 7.76666 6.56675 6.56666C7.76675 5.36666 9.17786 4.41666 10.8001 3.71666C12.4223 3.01666 14.1556 2.66666 16.0001 2.66666C17.8445 2.66666 19.5779 3.01666 21.2001 3.71666C22.8223 4.41666 24.2334 5.36666 25.4334 6.56666C26.6334 7.76666 27.5834 9.17777 28.2834 10.8C28.9834 12.4222 29.3334 14.1555 29.3334 16C29.3334 17.8444 28.9834 19.5778 28.2834 21.2C27.5834 22.8222 26.6334 24.2333 25.4334 25.4333C24.2334 26.6333 22.8223 27.5833 21.2001 28.2833C19.5779 28.9833 17.8445 29.3333 16.0001 29.3333ZM16.0001 26.6667C18.9556 26.6667 21.4723 25.6278 23.5501 23.55C25.6279 21.4722 26.6667 18.9555 26.6667 16C26.6667 13.0444 25.6279 10.5278 23.5501 8.44999C21.4723 6.37221 18.9556 5.33332 16.0001 5.33332C13.0445 5.33332 10.5279 6.37221 8.45008 8.44999C6.3723 10.5278 5.33341 13.0444 5.33341 16C5.33341 18.9555 6.3723 21.4722 8.45008 23.55C10.5279 25.6278 13.0445 26.6667 16.0001 26.6667Z"
      fill={color}
    />
  </svg>
);

export const IconDelete: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7 21C6.45 21 5.97917 20.8042 5.5875 20.4125C5.19583 20.0208 5 19.55 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8042 20.0208 18.4125 20.4125C18.0208 20.8042 17.55 21 17 21H7ZM17 6H7V19H17V6ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z"
      fill={color}
    />
  </svg>
);

export const IconPaperplane: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M28.1972 7.47199H28.1759C28.1439 7.46665 28.1119 7.46665 28.0799 7.47199C28.0639 7.47199 28.0479 7.46665 28.0319 7.47199L15.5892 9.73865C15.5466 9.74399 15.5092 9.76532 15.4719 9.78132L3.63724 11.9413C3.42924 11.9787 3.25857 12.1387 3.21591 12.3467C3.16791 12.5547 3.24791 12.7733 3.41857 12.896L7.93057 16.192L10.6932 24.1547C10.6932 24.16 10.6932 24.16 10.6932 24.16L10.6986 24.1707C10.7039 24.1813 10.7092 24.192 10.7146 24.2027C10.7306 24.24 10.7466 24.272 10.7732 24.3093C10.7839 24.3253 10.7999 24.336 10.8159 24.352C10.8372 24.3787 10.8586 24.4 10.8799 24.416C10.9012 24.432 10.9226 24.4427 10.9439 24.4533C10.9599 24.464 10.9759 24.48 10.9972 24.4853C11.0026 24.4907 11.0079 24.4907 11.0132 24.4907C11.0719 24.512 11.1359 24.528 11.1999 24.528C11.2052 24.528 11.2052 24.528 11.2052 24.528C11.2319 24.528 11.2639 24.528 11.2959 24.5227C11.3119 24.5173 11.3279 24.5067 11.3492 24.5013C11.3759 24.496 11.4026 24.4853 11.4346 24.4693C11.4666 24.4533 11.4932 24.432 11.5252 24.4107C11.5412 24.4 11.5572 24.3947 11.5679 24.384L14.9759 21.1627L17.7066 23.056C17.7972 23.12 17.9039 23.152 18.0106 23.152C18.0426 23.152 18.0746 23.152 18.1066 23.1467C18.2452 23.12 18.3679 23.04 18.4479 22.9227L20.4586 20.016C20.5652 19.984 20.6612 19.9253 20.7306 19.8293L28.7039 8.29865C28.8372 8.10665 28.8319 7.84532 28.6826 7.66399C28.5652 7.51465 28.3786 7.45065 28.1972 7.47199ZM10.8266 17.36C10.7946 17.3813 10.7679 17.4027 10.7412 17.424C10.7359 17.4293 10.7252 17.4347 10.7199 17.44L10.7146 17.4453C10.7039 17.456 10.6986 17.4667 10.6879 17.4773C10.6719 17.504 10.6506 17.5253 10.6346 17.552L10.6292 17.5573C10.6239 17.5733 10.6186 17.5893 10.6079 17.6C10.5972 17.6267 10.5866 17.6533 10.5812 17.68C10.5759 17.68 10.5759 17.6853 10.5759 17.6907C10.5706 17.7067 10.5706 17.7227 10.5706 17.7387C10.5652 17.76 10.5599 17.7813 10.5599 17.8027V17.8347L10.6079 20.656L9.11457 16.352L20.8159 11.5947L10.8266 17.36Z"
      fill={color}
    />
  </svg>
);

export const IconSend: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4 26.6667V5.33334L29.3333 16L4 26.6667ZM6.66667 22.6667L22.4667 16L6.66667 9.33334V14L14.6667 16L6.66667 18V22.6667Z"
      fill={color}
    />
  </svg>
);

export const IconUndo: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.33337 25.3333V22.6667H18.8C20.2 22.6667 21.4167 22.2222 22.45 21.3333C23.4834 20.4445 24 19.3333 24 18C24 16.6667 23.4834 15.5556 22.45 14.6667C21.4167 13.7778 20.2 13.3333 18.8 13.3333H10.4L13.8667 16.8L12 18.6667L5.33337 12L12 5.33334L13.8667 7.20001L10.4 10.6667H18.8C20.9556 10.6667 22.8056 11.3667 24.35 12.7667C25.8945 14.1667 26.6667 15.9111 26.6667 18C26.6667 20.0889 25.8945 21.8333 24.35 23.2333C22.8056 24.6333 20.9556 25.3333 18.8 25.3333H9.33337Z"
      fill={color}
    />
  </svg>
);

export const IconBlock: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16 29.3333C14.1555 29.3333 12.4222 28.9833 10.8 28.2833C9.17774 27.5833 7.76663 26.6333 6.56663 25.4333C5.36663 24.2333 4.41663 22.8222 3.71663 21.2C3.01663 19.5778 2.66663 17.8444 2.66663 16C2.66663 14.1555 3.01663 12.4222 3.71663 10.8C4.41663 9.17777 5.36663 7.76666 6.56663 6.56666C7.76663 5.36666 9.17774 4.41666 10.8 3.71666C12.4222 3.01666 14.1555 2.66666 16 2.66666C17.8444 2.66666 19.5777 3.01666 21.2 3.71666C22.8222 4.41666 24.2333 5.36666 25.4333 6.56666C26.6333 7.76666 27.5833 9.17777 28.2833 10.8C28.9833 12.4222 29.3333 14.1555 29.3333 16C29.3333 17.8444 28.9833 19.5778 28.2833 21.2C27.5833 22.8222 26.6333 24.2333 25.4333 25.4333C24.2333 26.6333 22.8222 27.5833 21.2 28.2833C19.5777 28.9833 17.8444 29.3333 16 29.3333ZM16 26.6667C17.2 26.6667 18.3555 26.4722 19.4666 26.0833C20.5777 25.6944 21.6 25.1333 22.5333 24.4L7.59996 9.46666C6.86663 10.4 6.30551 11.4222 5.91663 12.5333C5.52774 13.6444 5.33329 14.8 5.33329 16C5.33329 18.9778 6.36663 21.5 8.43329 23.5667C10.5 25.6333 13.0222 26.6667 16 26.6667ZM24.4 22.5333C25.1333 21.6 25.6944 20.5778 26.0833 19.4667C26.4722 18.3555 26.6666 17.2 26.6666 16C26.6666 13.0222 25.6333 10.5 23.5666 8.43332C21.5 6.36666 18.9777 5.33332 16 5.33332C14.8 5.33332 13.6444 5.52777 12.5333 5.91666C11.4222 6.30555 10.4 6.86666 9.46663 7.59999L24.4 22.5333Z"
      fill={color}
    />
  </svg>
);

export const IconCheckCircle: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14.1334 22.1333L23.5334 12.7333L21.6667 10.8667L14.1334 18.4L10.3334 14.6L8.46675 16.4667L14.1334 22.1333ZM16.0001 29.3333C14.1556 29.3333 12.4223 28.9833 10.8001 28.2833C9.17786 27.5833 7.76675 26.6333 6.56675 25.4333C5.36675 24.2333 4.41675 22.8222 3.71675 21.2C3.01675 19.5778 2.66675 17.8444 2.66675 16C2.66675 14.1555 3.01675 12.4222 3.71675 10.8C4.41675 9.17777 5.36675 7.76666 6.56675 6.56666C7.76675 5.36666 9.17786 4.41666 10.8001 3.71666C12.4223 3.01666 14.1556 2.66666 16.0001 2.66666C17.8445 2.66666 19.5779 3.01666 21.2001 3.71666C22.8223 4.41666 24.2334 5.36666 25.4334 6.56666C26.6334 7.76666 27.5834 9.17777 28.2834 10.8C28.9834 12.4222 29.3334 14.1555 29.3334 16C29.3334 17.8444 28.9834 19.5778 28.2834 21.2C27.5834 22.8222 26.6334 24.2333 25.4334 25.4333C24.2334 26.6333 22.8223 27.5833 21.2001 28.2833C19.5779 28.9833 17.8445 29.3333 16.0001 29.3333ZM16.0001 26.6667C18.9779 26.6667 21.5001 25.6333 23.5667 23.5667C25.6334 21.5 26.6667 18.9778 26.6667 16C26.6667 13.0222 25.6334 10.5 23.5667 8.43332C21.5001 6.36666 18.9779 5.33332 16.0001 5.33332C13.0223 5.33332 10.5001 6.36666 8.43341 8.43332C6.36675 10.5 5.33341 13.0222 5.33341 16C5.33341 18.9778 6.36675 21.5 8.43341 23.5667C10.5001 25.6333 13.0223 26.6667 16.0001 26.6667Z"
      fill={color}
    />
  </svg>
);

export const IconChatBubbleOff: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M26.6667 24V5.33332H9.13335L6.46668 2.66666H26.6667C27.4 2.66666 28.0278 2.92777 28.55 3.44999C29.0722 3.97221 29.3334 4.59999 29.3334 5.33332V21.3333C29.3334 22.0667 29.0722 22.6944 28.55 23.2167C28.0278 23.7389 27.4 24 26.6667 24ZM27.3334 31.0667L20.2 24H8.00002L2.66668 29.3333V6.39999L0.93335 4.66666L2.80002 2.79999L29.2 29.2L27.3334 31.0667ZM5.33335 9.06666V24L8.00002 21.3333H17.6L5.33335 9.06666Z"
      fill={color}
    />
  </svg>
);

export const IconArrowOutward: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.53341 24L6.66675 22.1333L19.4667 9.33332H8.00008V6.66666H24.0001V22.6667H21.3334V11.2L8.53341 24Z"
      fill={color}
    />
  </svg>
);

export const IconDoNotDisturb: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.33329 17.3333H22.6666V14.6667H9.33329V17.3333ZM16 29.3333C14.1555 29.3333 12.4222 28.9833 10.8 28.2833C9.17774 27.5833 7.76663 26.6333 6.56663 25.4333C5.36663 24.2333 4.41663 22.8222 3.71663 21.2C3.01663 19.5778 2.66663 17.8444 2.66663 16C2.66663 14.1555 3.01663 12.4222 3.71663 10.8C4.41663 9.17777 5.36663 7.76666 6.56663 6.56666C7.76663 5.36666 9.17774 4.41666 10.8 3.71666C12.4222 3.01666 14.1555 2.66666 16 2.66666C17.8444 2.66666 19.5777 3.01666 21.2 3.71666C22.8222 4.41666 24.2333 5.36666 25.4333 6.56666C26.6333 7.76666 27.5833 9.17777 28.2833 10.8C28.9833 12.4222 29.3333 14.1555 29.3333 16C29.3333 17.8444 28.9833 19.5778 28.2833 21.2C27.5833 22.8222 26.6333 24.2333 25.4333 25.4333C24.2333 26.6333 22.8222 27.5833 21.2 28.2833C19.5777 28.9833 17.8444 29.3333 16 29.3333ZM16 26.6667C18.9777 26.6667 21.5 25.6333 23.5666 23.5667C25.6333 21.5 26.6666 18.9778 26.6666 16C26.6666 13.0222 25.6333 10.5 23.5666 8.43332C21.5 6.36666 18.9777 5.33332 16 5.33332C13.0222 5.33332 10.5 6.36666 8.43329 8.43332C6.36663 10.5 5.33329 13.0222 5.33329 16C5.33329 18.9778 6.36663 21.5 8.43329 23.5667C10.5 25.6333 13.0222 26.6667 16 26.6667Z"
      fill={color}
    />
  </svg>
);

export const IconRemoveCircle: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16 29.3333C14.1555 29.3333 12.4222 28.9833 10.8 28.2833C9.17774 27.5833 7.76663 26.6333 6.56663 25.4333C5.36663 24.2333 4.41663 22.8222 3.71663 21.2C3.01663 19.5778 2.66663 17.8444 2.66663 16C2.66663 14.1555 3.01663 12.4222 3.71663 10.8C4.41663 9.17777 5.36663 7.76666 6.56663 6.56666C7.76663 5.36666 9.17774 4.41666 10.8 3.71666C12.4222 3.01666 14.1555 2.66666 16 2.66666C17.8444 2.66666 19.5777 3.01666 21.2 3.71666C22.8222 4.41666 24.2333 5.36666 25.4333 6.56666C26.6333 7.76666 27.5833 9.17777 28.2833 10.8C28.9833 12.4222 29.3333 14.1555 29.3333 16C29.3333 17.8444 28.9833 19.5778 28.2833 21.2C27.5833 22.8222 26.6333 24.2333 25.4333 25.4333C24.2333 26.6333 22.8222 27.5833 21.2 28.2833C19.5777 28.9833 17.8444 29.3333 16 29.3333ZM16 26.6667C18.9777 26.6667 21.5 25.6333 23.5666 23.5667C25.6333 21.5 26.6666 18.9778 26.6666 16C26.6666 13.0222 25.6333 10.5 23.5666 8.43332C21.5 6.36666 18.9777 5.33332 16 5.33332C13.0222 5.33332 10.5 6.36666 8.43329 8.43332C6.36663 10.5 5.33329 13.0222 5.33329 16C5.33329 18.9778 6.36663 21.5 8.43329 23.5667C10.5 25.6333 13.0222 26.6667 16 26.6667Z"
      fill={color}
    />
  </svg>
);

export const IconEdit: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.66667 25.3333H8.56667L21.6 12.3L19.7 10.4L6.66667 23.4333V25.3333ZM4 28V22.3333L21.6 4.76667C21.8667 4.52222 22.1611 4.33333 22.4833 4.2C22.8056 4.06667 23.1444 4 23.5 4C23.8556 4 24.2 4.06667 24.5333 4.2C24.8667 4.33333 25.1556 4.53333 25.4 4.8L27.2333 6.66667C27.5 6.91111 27.6944 7.2 27.8167 7.53333C27.9389 7.86667 28 8.2 28 8.53333C28 8.88889 27.9389 9.22778 27.8167 9.55C27.6944 9.87222 27.5 10.1667 27.2333 10.4333L9.66667 28H4ZM20.6333 11.3667L19.7 10.4L21.6 12.3L20.6333 11.3667Z"
      fill={color}
    />
  </svg>
);

export const IconTrash: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7 21C6.45 21 5.97917 20.8042 5.5875 20.4125C5.19583 20.0208 5 19.55 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8042 20.0208 18.4125 20.4125C18.0208 20.8042 17.55 21 17 21H7ZM17 6H7V19H17V6ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z"
      fill={color}
    />
  </svg>
);

export const IconContentCopy: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9 18C8.45 18 7.97917 17.8042 7.5875 17.4125C7.19583 17.0208 7 16.55 7 16V4C7 3.45 7.19583 2.97917 7.5875 2.5875C7.97917 2.19583 8.45 2 9 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V16C20 16.55 19.8042 17.0208 19.4125 17.4125C19.0208 17.8042 18.55 18 18 18H9ZM9 16H18V4H9V16ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6H5V20H16V22H5Z"
      fill={color}
    />
  </svg>
);
export const IconInfo: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
      fill={color}
    />
  </svg>
);

export const IconGif: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-8-2h2v-4h2V8h-4v2h2v2h-2v2zm-2-2H8v-4h2V6H6v8h4v-2zm8-2h-2V8h2V6h-4v8h2v-2h2v-2z"
      fill={color}
    />
  </svg>
);

export const IconRefresh: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
      fill={color}
    />
  </svg>
);

export const IconFullscreen: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
      fill={color}
    />
  </svg>
);
